import config from 'config';

export const domain = () => {
  let domain = window.location.hostname.toLowerCase();

  if (process.env.NODE_ENV !== 'production' && (domain === 'localhost' || domain.indexOf('192') === 0)) {
    domain = config.WHITELABEL_DOMAIN;
  }

  return domain;
};